module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div ng-show=\"$ctrl.showApp()\">\n  <div ui-view></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 1067
// module chunks = 0